<template>
<v-text-field :label="label" outline hide-details class="custom-input" :value="value" readonly @click="$emit('click', $event)">
    <template v-slot:append-outer>
        <v-btn fab small @click="increment">
            <v-icon>add</v-icon>
        </v-btn>
    </template>
    <template v-slot:prepend>
        <v-btn fab small @click="decrement">
            <v-icon>remove</v-icon>
        </v-btn>
    </template>
</v-text-field>
</template>
<script>
export default {
    props: {
        label: {
            type: String,
            required: true
        },        
        value: {
            type: String,
            required: true
        }
    },
    methods: {
        increment() {
            this.$emit('increment');
        },
        decrement() {
            this.$emit('decrement');
        }
    }
}
</script>
<style scoped>
.custom-input>>>.v-input__append-outer {
    margin-top: 1px;
}

.custom-input>>>.v-input__prepend-outer {
    margin-top: 1px;
}

.v-icon {
    display: inline-flex !important;
}

</style>
